import { useMutation } from "@tanstack/react-query"
import { Loader2Icon } from "lucide-react"
import { useCallback, useState } from "react"
import { useNavigate } from "react-router-dom"
import { getNextVerificationStep, NextStepResponse } from "@/api/api"
import { useCurrentToken } from "@/lib/use-current-token"
import { parseError } from "@/lib/utils"
import { Alert } from "./ui/alert"
import { Button } from "./ui/button"

const NextStep = (props: { beforeContinue?: () => Promise<null> }) => {
  const navigate = useNavigate()
  const { token_id } = useCurrentToken()
  const [isRedirecting, setIsRedirecting] = useState(false)

  const onNextStep = useCallback(
    (res: NextStepResponse) => {
      if (res.next_step) {
        const path = res.next_step.split("_")[0]
        navigate(`/${token_id}/${path}`)
      } else if (res.redirect_url) {
        setIsRedirecting(true)

        if (
          res.redirect_url === "signature" ||
          res.redirect_url === "payment"
        ) {
          navigate(`/${token_id}/${res.redirect_url}`)
        } else {
          window.location.href = res.redirect_url
        }
      }
    },
    [navigate, token_id],
  )

  const mutation = useMutation({
    mutationKey: ["getNextStep", { token_id }],
    mutationFn: async () => {
      if (props.beforeContinue) {
        await props.beforeContinue()
      }
      return await getNextVerificationStep()
    },
    onSuccess: onNextStep,
  })

  return (
    <div className="flex w-full flex-col items-center gap-4">
      {mutation.isError && (
        <Alert variant="destructive" className="w-full md:w-auto">
          {parseError(mutation.error)}
        </Alert>
      )}
      <Button
        className="w-full md:w-auto"
        disabled={mutation.isPending || isRedirecting}
        onClick={() => mutation.mutate()}
      >
        {mutation.isPending || isRedirecting ? (
          <>
            <Loader2Icon className="mr-2 animate-spin" />
            <span>Cargando...</span>
          </>
        ) : (
          <span>Continuar</span>
        )}
      </Button>
    </div>
  )
}

export { NextStep }
